<template>
    <div>
        <span v-if="transaction.deleted" class="text-error mr-2">[SLETTET]</span>
        <span v-else-if="transaction.updated" class="text-gray-400 mr-2">[ENDRET]</span>
        <span :class="{'opacity-50':transaction.deleted}">{{ transaction.description }}</span>
    </div>
</template>

<script setup lang="ts">

import {Transaction} from '@/types/transaction/Transaction'
import {computed, provide} from 'vue'

const props = defineProps({
    params: {
        type: Object as () => {
            data: Transaction,
            context: {
                panelId: Number,
                panelPathSegment: String
            },
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const transaction = computed(() => {
    return props.params.data
})

</script>

<style scoped>

</style>